module.exports = __webpack_public_path__ + "img/banner_msi.27ed51d6.png";